import Resources from '../../../helpers/resources';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorActions from '../../app/errors/errors-actions';
import { ENDPOINT_PATH_SKILL_QUESTS_MASTERY } from '../../../helpers/constants';

export const SKILL_QUESTS_MASTERY_CLASS_RETRIEVED =
    'SKILL_QUESTS_MASTERY_CLASS_RETRIEVED';
export const SKILL_QUESTS_MASTERY_CLASS_REQUEST =
    'SKILL_QUESTS_MASTERY_CLASS_REQUEST';

const manageGroupsData = (groupsData) => {
    groupsData.groups.map((groupLevel) => {
        groupLevel.id = groupLevel.groupId;
        groupLevel.students.map((studentLevel) => {
            studentLevel.id = studentLevel.studentUserProfileId;
            return studentLevel;
        });
        return groupLevel;
    });

    return groupsData;
};

function getClassSkillQuestsMasteryData(
    classroomId,
    selectedDateFilter,
    assignmentResultType
) {
    return (dispatch) => {
        dispatch({ type: SKILL_QUESTS_MASTERY_CLASS_REQUEST });
        Resources.singleClassReport
            .get({
                reportType: ENDPOINT_PATH_SKILL_QUESTS_MASTERY,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId
            })
            .withParams({
                ...DateParamHelper.getDateQueryParams(selectedDateFilter),
                assignmentResultType
            })
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch({
                        type: SKILL_QUESTS_MASTERY_CLASS_RETRIEVED,
                        payload: manageGroupsData(payload.data)
                    });
                } else {
                    dispatch(
                        errorActions.addError(
                            SKILL_QUESTS_MASTERY_CLASS_RETRIEVED
                        )
                    );
                }
            });
    };
}

export default {
    getClassSkillQuestsMasteryData
};



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/single-class/single-class-actions.js